<template>
  <v-app id="app" class="SimomicsEPV" data-vuetify>
    <v-main>

      <!-- PC -->
      <v-card flat color="white" style="padding-bottom: 20px;">

        <selectorsPC v-if="filters && isPC" :filters="filters" @resetAll="resetAll=!resetAll"></selectorsPC>
        <selectorsMobile v-else-if="filters" :filters="filters" style="margin-top: 10px;" @resetAll="resetAll=!resetAll">
        </selectorsMobile>

        <!-- TODO: clean up v-if logic here. -->
        <charts v-if="mec" :rq="rq" :mec="mec" :geo="geo" :stats="stats" :pnec="pnec" :isMobile="!isPC" :reset="resetAll"></charts>
      </v-card>


    </v-main>
  </v-app>
</template>

<script>
  import { Filters } from './ts/filters'
  import { Stats } from './ts/stats'
  import { RQ } from './ts/rq'
  import { MEC } from './ts/mec'
  import { Geo } from './ts/geo'
  import { PNEC } from './ts/pnec'
  import selectorsMobile from './components/selectors/selectorsMobile.vue'
  import selectorsPC from './components/selectors/selectorsPC.vue'

  export default {
    components: {
      selectorsMobile,
      selectorsPC,
      charts: () => import('./components/charts/charts.vue')
    },

    data() {
      return {
        // Vuetify's breakpoint takes 200ms+ to update - so we handle resize directly.
        isPC: this.$vuetify.breakpoint.mdAndUp,

        stats: null,
        mec: null,
        filters: null,
        rq: null,
        geo: null,
        pnec: null,
        resetAll: false,
      }
    },

    mounted() {
      window.addEventListener('resize', this.resize)
      this.resize()

      this.filters = new Filters(this.update)

      this.$nextTick(() => {
        this.update()
      })
    },
    destroyed() {
      window.removeEventListener("resize", this.resize)
    },

    watch: {
      filters: {
        deep: true,
        handler() {
          this.update()
        }
      }
    },

    methods: {
      update() {
        const [mecsFiltered, pnecsFiltered, rqsFiltered] = this.filters.getFilteredData()
        this.stats = new Stats(mecsFiltered, pnecsFiltered)
        this.mec = new MEC(mecsFiltered, pnecsFiltered)
        this.rq = new RQ(rqsFiltered, this.filters.detects)
        this.geo = new Geo(mecsFiltered, this.filters.detects.isShow())
        this.pnec = new PNEC(pnecsFiltered)
      },

      resize() {
        this.isPC = (window.innerWidth >= 960)
      },
    },
  }

</script>

<style scoped>
  .v-application {
    font-family: "Lexia" !important;
    overflow: hidden !important;
  }
</style>

<style>
  .SimomicsEPV text {
    font-family: "Lexia" !important;
  }

  .SimomicsEPV .v-application--wrap {
    min-height: 100%
  }
</style>